import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

const Highcharts = require('highcharts');

require('highcharts/modules/exporting')(Highcharts);

declare var require: any;

@Component({
    selector: 'page-visao-gerencial',
    templateUrl: 'visao-gerencial.html',
    providers: [
        PessoalService
    ]
})

export class VisaoGerencialPessoalPage extends ModulosController {
    @ViewChild('chart') public chartEl: ElementRef;

    listaDados: any = [];
    listaDadosAux: any = [];
    listaDadosElementoDespesa: any = [];
    listaDadosElementoDespesaData: any = [];
    listaDadosJson: any;

    drilldownText: any = '';

    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "100";
    options: Object;

    private _chart: any;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(11);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    carregarDados() {
        this.pessoalService.obterVisaoGerencial().subscribe(data => {

            this.listaDadosJson = data;

            if (data != null && data.vinculos != null) {

                this.listaDados = data.vinculos.map((elem) => ([elem.dsGrupoCargo, elem.qtdGrupoCargo]));                

                this.carregarGrafico();
            }

            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    carregarGrafico() {

        let opts: any = {
            title: { text: 'Visão Gerencial do Quadro de Pessoal' },
            credits: {
                enabled: false
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Quantidade'
                }
            },
            xAxis: {
                type: 'category',
                labels: {
                    style: {
                        fontSize: '9px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            },
            tooltip: {
                formatter: function () {
                    var seriesData = this.series.data;

                    var total = 0;
                    for (var i = 0; i < seriesData.length; i++) {
                        total += seriesData[i].y
                    }

                    return '<span style="font-size:13px">' + this.series.data[this.x].name + '</span><br><br/>' +
                        '<b>' + (100 * this.y / total).toFixed(2) + '%</b> do total<br/><br/>' +
                        '<span style="color:' + this.color + '">Qtde</span>.: <b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b><br/>' +
                        '<span style="color:' + this.color + '">Total</span>: <b>' + Highcharts.numberFormat(total, 2, ',', '.') + '</b><br/>';
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            var seriesData = this.series.data;

                            var total = 0;
                            for (var i = 0; i < seriesData.length; i++) {
                                total += seriesData[i].y
                            }

                            return (100 * this.y / total).toFixed(2) + "%";
                        }
                    }
                }
            },
            series: [{
                name: 'Vínculos',
                colorByPoint: true,
                data: this.listaDados
            }],
            exporting: {
                enabled: true,
                sourceWidth: 1920
            }
        };

        if (this.chartEl && this.chartEl.nativeElement) {
            opts.chart = {
                type: 'column',
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                backgroundColor: 'transparent',
                renderTo: this.chartEl.nativeElement
            };

            this._chart = new Highcharts.Chart(opts);
        }

    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaPessoal() {
        this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
    }

    submeterNoCertificado() {
        let idAnalise = "";
        this.loading = true;
        if (this.listaDadosJson.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDadosJson.resultadoAnalise == null || this.listaDadosJson.resultadoAnalise == undefined || !this.listaDadosJson.resultadoAnalise) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDadosJson) {
                idAnalise = this.listaDadosJson.idModuloAnalise;

                this.pessoalService.finalizarVisaoGerencial(this.listaDadosJson).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaPessoal();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    salvarComentario() {
        this.loading = true;
        if (this.listaDadosJson) {
            this.listaDadosJson.resultadoAnalise = this.capitalize(this.listaDadosJson.resultadoAnalise);
            this.pessoalService.salvarVisaoGerencial(this.listaDadosJson).subscribe(data => {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.loading = false;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
                this.loading = false;
            });
        }
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/visao-gerencial/visao-gerencial.ts